import { render, staticRenderFns } from "./IntentionSchool.vue?vue&type=template&id=0601e709&scoped=true"
import script from "./IntentionSchool.vue?vue&type=script&lang=js"
export * from "./IntentionSchool.vue?vue&type=script&lang=js"
import style0 from "./IntentionSchool.vue?vue&type=style&index=0&id=0601e709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0601e709",
  null
  
)

export default component.exports